// 400系基底クラス
export class ClientError extends Error {
  public readonly status: number;

  constructor(status: number, message: string) {
    super(message);
    this.status = status;
    this.name = 'ClientError';
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

// 500系基底クラス
export class ServerError extends Error {
  public readonly status: number;

  constructor(status?: number, message?: string) {
    super(message ?? '想定外エラー');
    this.status = status ?? 500;
    this.name = 'ServerError';
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

// --- 400系個別クラス ---

export class BadRequestError extends ClientError {
  constructor(message: string = 'Bad Request') {
    super(400, message);
    this.name = 'BadRequestError';
  }
}

export class UnauthorizedError extends ClientError {
  constructor(message: string = 'Unauthorized') {
    super(401, message);
    this.name = 'UnauthorizedError';
  }
}

export class ForbiddenError extends ClientError {
  constructor(message: string = 'Forbidden') {
    super(403, message);
    this.name = 'ForbiddenError';
  }
}

export class NotFoundError extends ClientError {
  constructor(message: string = 'Not Found') {
    super(404, message);
    this.name = 'NotFoundError';
  }
}

export class ConflictError extends ClientError {
  constructor(message: string = 'Conflict') {
    super(409, message);
    this.name = 'ConflictError';
  }
}

// --- ファクトリ関数 ---

export const createApiError = (status: number, message: string): ClientError | ServerError => {
  switch (status) {
    case 400:
      return new BadRequestError(message);
    case 401:
      return new UnauthorizedError(message);
    case 403:
      return new ForbiddenError(message);
    case 404:
      return new NotFoundError(message);
    case 409:
      return new ConflictError(message);
    default:
      if (status >= 400 && status < 500) {
        return new ClientError(status, message);
      }
      return new ServerError(status, message);
  }
};
